import TemplateView from '../../TemplateView'
import $ from 'jquery'
import messageResource from '../../messageResource'
import {KEY_CODE_ENTER, KEY_CODE_SPACE} from '../../keyCodes'
import {cancelBubble} from "../../atBrowserUtils"

export default class DeleteConfirmationDialog extends TemplateView {
    constructor($container, cancelHandler, deleteHandler) {
        super($container);

        this.cancelHandler = cancelHandler;
        this.deleteHandler = deleteHandler;

        this.state = {
            hasManagerApprover: false,
            entityName: "",
            entitiesToDeleteCount: 0,
            entitiesBlocked: [],
            entitiesBlockedCount: 0,
            entitiesBlockedDueToLockedTimeCount: 0,
            entitiesBlockedDueToUnavailableToModifyTimeTrackCount: 0,
            entitiesWithManagerTimeTrackCount: 0,
            entitiesWithOtherUsersTimeTrackCount: 0,
            entitiesWithManagerApprovedTimeTrackCount: 0,
            entitiesWithOtherUsersApprovedTimeTrackCount: 0
        };

        this.onStateChanged(() => this.updateTitles());
    }

    templateHtml() {
        return '<div class="operationConfirmDialog">' +
               '  <div class="operationConfirmDialogInnerContainer">' +
               '    <div class="warningIcon"></div>' +
               '    <div class="title"></div>' +
               '    <div class="orangeBlock">' +
               '      <span class="first"></span>' +
               '      <br>' +
               '      <span class="second"></span>' +
               '    </div>' +
               '    <ul class="pointsBlock">' +
               '      <li class="point entities"></li>' +
               '      <li class="point timetrack"></li>' +
               '      <li class="point managerApproveWeeksPoint"></li>' +
               '      <li class="point approveWeeksPoint"><%-approveRejectWeeksText%></li>' +
               '      <div class="choiceApprovalWeeks">' +
               '        <div class="weeksStatusRadioButton">' +
               '          <label>' +
               '            <input type="radio" value="true" class="revokeWeeksStatuses" name="revokeStatus" checked><%=revokeWeeksStatusesLabel%></label>' +
               '        </div>' +
               '        <div class="weeksStatusRadioButton">' +
               '          <label><input type="radio" value="false" class="keepWeeksStatuses" name="revokeStatus"><%=keepWeeksStatusesLabel%></label>' +
               '        </div>' +
               '      </div>' +
               '    </ul>' +
               '    <div class="blockedWarningContainer">' +
               '      <div class="link"></div>' +
               '      <div class="other"></div>' +
               '    </div>' +
               '    <div class="buttonsContainer">' +
               '      <div class="submitBtn withIcon commitBtn greyButton" tabindex="-1">' +
               '        <div class="buttonIcon">' +
               '          <span class="submitTitle buttonTitle"></span>' +
               '        </div>' +
               '      </div>' +
               '      <div class="cancelBtn greyButton"><%=cancelButtonText%></div>' +
               '    </div>' +
               '  </div>' +
               '</div>';
    }

    messageKeys() {
        return {
            approveRejectWeeksText: "delete.confirm.dialog.about_approve_weeks",
            revokeWeeksStatusesLabel: "delete.confirm.dialog.revoke_weeks_statuses_label",
            keepWeeksStatusesLabel: "delete.confirm.dialog.keep_weeks_statuses_label",
            cancelButtonText: "delete.confirm.dialog.cancel"
        };
    }

    afterRender()
    {
        this.$revokeWeeksStatusesButton = this.find(".revokeWeeksStatuses")
        this.setHandlers();
    }

    allBlocked()
    {
        return this.state.entitiesBlockedCount === this.state.entitiesToDeleteCount
    }

    someBlocked()
    {
        return this.state.entitiesBlockedCount > 0 && this.state.entitiesBlockedCount < this.state.entitiesToDeleteCount;
    }

    hasTimeTrack()
    {
        return this.state.entitiesWithOtherUsersTimeTrackCount > 0 || this.state.entitiesWithManagerTimeTrackCount > 0
    }

    hasApprovedWeeks()
    {
        return this.state.entitiesWithOtherUsersApprovedTimeTrackCount > 0
    }

    hasManagerApprovedWeeksAndApprover()
    {
        return this.state.entitiesWithManagerApprovedTimeTrackCount > 0 && this.state.hasManagerApprover;
    }

    show()
    {
        super.show();

        this._setSavingState(false)

        if (this.showHandler)
            this.showHandler();
        const self = this
        const $submitBtn = this.find(".submitBtn")
        $submitBtn.off("keydown").on("keydown", function(event)
                                                {
                                                    switch (event.keyCode)
                                                    {
                                                        case KEY_CODE_SPACE:
                                                        case KEY_CODE_ENTER:
                                                            self.onSubmit();
                                                            cancelBubble(event.originalEvent);
                                                            return false;
                                                    }
                                                });
        if (this.blockedEntitiesList)
            this.blockedEntitiesList.setDisabled(false);

        this.$revokeWeeksStatusesButton.prop("checked", true);
    }
    
    setHandlers()
    {
        this.find(".cancelBtn").unbind().click(() => this.onCancel())
        this.find(".submitBtn").unbind().click(() => this.onSubmit())
    }

    onCancel()
    {
        if (this.savingState)
            return;

        this._setSavingState(false)
        this._removeBlockedEntitiesList();
        this.cancelHandler();
    }

    hide(){
        this._setSavingState(false)
        this._removeBlockedEntitiesList();
        super.hide();
    }

    onSubmit()
    {
        if (this.savingState)
            return;

        this._setSavingState(true)

        var revokeStatuses =  $("input[name='revokeStatus']:checked").val();
        this.deleteHandler(revokeStatuses);
    }

    updateTitles() {
        this.find(".title").text(this.titleText());
        this.find(".orangeBlock .first").text(this.firstOrangeSentence());
        this.find(".orangeBlock .second").text(this.secondOrangeSentence());
        this.find(".pointsBlock .entities").text(this.removeEntitiesPointText());
        this.find(".pointsBlock .timetrack").text(this.removeTimeTrackPointText());
        this.find(".pointsBlock .managerApproveWeeksPoint").text(this.getRemoveManagerApprovedTimeTrackText());
        this.find(".blockedWarningContainer .link").text(this.blockedWarningLinkText());
        this.find(".blockedWarningContainer .other").text(this.blockedWarningOtherText());
        this.find(".buttonTitle").text(this.deleteButtonText());

        this.$el.toggleClass("allBlocked", this.allBlocked());
        this.$el.toggleClass("someBlocked", this.someBlocked());
        this.$el.toggleClass("hasTimeTrack", this.hasTimeTrack());
        this.$el.toggleClass("hasApprovedWeeks", this.hasApprovedWeeks());
        this.$el.toggleClass("hasManagerApprovedWeeksAndApprover", this.hasManagerApprovedWeeksAndApprover());

        var $blockedWarningLink = this.find(".blockedWarningContainer .link")
        this._removeBlockedEntitiesList()
        var blockedEntitiesList = this.blockedEntitiesList = this.createBlockedEntitiesList()
        $blockedWarningLink.click(function()
        {
            if (!blockedEntitiesList.isDisabled())
                blockedEntitiesList.showAt($blockedWarningLink, {
                    offset: "10px 20px",
                    at: "right bottom",
                    my: "left bottom",
                    collision: "none"
                });
        });
    }

    getRemoveManagerApprovedTimeTrackText()
    {
        return messageResource.getMessage(this.state.entitiesWithManagerApprovedTimeTrackCount > 1 ?
                                          "delete.confirm.dialog.about_approved_manager_time_track" :
                                          "delete.confirm.dialog.about_approved_manager_time_track_one_task");
    }

    createBlockedEntitiesList()
    {
        // Abstract
    }

    titleText()
    {
        // Abstract
    }

    firstOrangeSentence()
    {
        // Abstract
    }

    secondOrangeSentence()
    {
        // Abstract
    }

    removeEntitiesPointText()
    {
        // Abstract
    }

    removeTimeTrackPointText()
    {
        // Abstract
    }

    blockedWarningLinkText()
    {
        // Abstract
    }

    blockedWarningOtherText()
    {
        // Abstract
    }

    deleteButtonText()
    {
        // Abstract
    }

    _setSavingState(saving) {
        this.$el.toggleClass('savingState', saving)
        this.savingState = saving
    }

    _removeBlockedEntitiesList() {
        if (this.blockedEntitiesList){
            this.blockedEntitiesList.setDisabled(true);
            this.blockedEntitiesList.$el.remove();
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/cptManagement/deleteConfirmationDialog/DeleteConfirmationDialog.js